class Clientes  {
    test = ()=>{
    }  
    setAuthentication = (client, nit) =>{
      // console.log("llegue el listado de clientes",client);
      
      localStorage.setItem('client',JSON.stringify(client));
      localStorage.setItem('nit',JSON.stringify(nit));

    //   localStorage.setItem('dataUser',dataUser[0].UsuarioId);
    //   localStorage.setItem('UserName',dataUser[0].Nombre);
    //   localStorage.setItem('UserNameLast',dataUser[0].Apellido);
    //   localStorage.setItem('RolId',dataUser[0].RolId);
    //   localStorage.setItem('DATAUSER',dataUser.toString());
    //   localStorage.setItem('customerSelect',JSON.stringify(customerSelect));
      // localStorage.setItem('data',dataUser)
    }
    getAuthentication = (value)=>{
      return localStorage.getItem(value);     
    }
    deleteAuthentication = (value)=>{
      localStorage.removeItem(value);
    }
}

export default Clientes;